import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { SendPostRequest } from "../http";
import { toast } from "react-toastify";
import "./ContactUs.css";

const MAP_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3325.118672522288!2d73.11908368244!3d33.550292875370666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfed04d81818a1%3A0xecfa8857f30563f7!2sCivic%20Center%20Bahria%20Town%20Civic%20Center%20Bahria%20Town%2C%20Rawalpindi%2C%20Islamabad%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1721368323831!5m2!1sen!2s";

function ContactUs() {
  const [message, setMessage] = useState({});
  const [loading, setLoading] = useState(false);
  const contactNumberInputRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Contact Us :: D-Right Technologies";
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    let err = null;
    if (name === "contact_number") {
      updatedValue = value.slice(0, 11);
      err = updatedValue.length < 11 ? "Invalid Contact Number" : null;
    }
    setMessage((prev) => ({ ...prev, [name]: updatedValue }));
    setError(err);
  };

  const validate = () => {
    const validNum = message.contact_number?.length === 11;
    if (!validNum) contactNumberInputRef.current?.focus();
    setError(validNum ? null : "Invalid Contact Number");
    return !!validNum;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const response = await SendPostRequest("contact-us", { 
        form_data: message,
        recipient_email: "info@dright.net",
      });
      if (response?.status === "success") {
        setMessage({});
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formFields = (
    <form onSubmit={handleSubmit} id="contactForm" className="contact-us-form">
      <div className="form-row">
        <div className="col-12">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              name="name"
              placeholder="Enter Your Name"
              required
              onChange={handleChange}
              value={message?.name || ""}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <input
              type="number"
              className={`form-control ${error ? "border-danger" : ""}`}
              name="contact_number"
              placeholder="Enter Contact Number"
              required
              onChange={handleChange}
              value={message?.contact_number || ""}
              ref={contactNumberInputRef}
            />
            {error && <small className="text-danger d-block mt-1">{error}</small>}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter Your Email"
              required
              onChange={handleChange}
              value={message?.email || ""}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <textarea
              name="message"
              id="message"
              className="form-control"
              rows="5"
              placeholder="Message"
              required
              onChange={handleChange}
              value={message?.message || ""}
            />
          </div>
        </div>
        <div className="col-12 mt-3">
          <button
            type="submit"
            className="btn btn-brand-02"
            id="btnContactUs"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </div>
      </div>
    </form>
  );

  const mapBlock = (
    <div className="cu-map-wrap">
      <iframe src={MAP_EMBED} title="Office location" allowFullScreen="" />
    </div>
  );

  return (
    <div>
      <Header />
      <div className="main cu-page cu-bento no-banner-top-padding">
        <section
          className="page-header-section ptb-100 bg-image"
          image-overlay="8"
        >
          <div
            className="background-image-wraper"
            style={{
              background: "url('/assets/img/contactus-banner.jpg')",
              opacity: "1",
            }}
          />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-9 col-lg-7">
                <div className="page-header-content text-white pt-4">
                  <h1 className="text-white mb-0">Contact Us</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="cu-section cu-bento">
          <div className="container">
            <div className="cu-bento-grid">
              <div className="cu-bento-form">
                <div className="cu-form-card">
                  <h4 className="mb-4">Get in touch</h4>
                  {formFields}
                </div>
              </div>
              <div className="cu-bento-loc">
                <div className="cu-info-card cu-info-card-loc">
                  <div className="cu-info-card-inner">
                    <div className="cu-icon-wrap">
                      <span className="fas fa-map-marker-alt" aria-hidden="true" />
                    </div>
                    <div className="cu-info-body">
                      <span className="cu-info-label">Visit us</span>
                      <h5 className="cu-info-title">Location</h5>
                      <p className="cu-info-text">131 Civic Center – Bahria Town Phase 4, Islamabad</p>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=131+Civic+Center+Bahria+Town+Phase+4+Islamabad"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cu-info-cta"
                      >
                        Get directions <span className="fas fa-arrow-right" aria-hidden="true" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cu-bento-mail">
                <div className="cu-info-card cu-info-card-mail">
                  <div className="cu-info-card-inner">
                    <div className="cu-icon-wrap">
                      <span className="fas fa-envelope" aria-hidden="true" />
                    </div>
                    <div className="cu-info-body">
                      <span className="cu-info-label">Reach out</span>
                      <h5 className="cu-info-title">Email</h5>
                      <a className="cu-info-email" href="mailto:info@dright.net">
                        info@dright.net
                      </a>
                      <a href="mailto:info@dright.net" className="cu-info-cta">
                        Send email <span className="fas fa-arrow-right" aria-hidden="true" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cu-bento-map">
                {mapBlock}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;
